import { EnginePowerUnit } from "@bus/models/dist/enums/new/engine-power-unit.enum";
import { VehicleData } from "../../common/types/vehicleData";

export function calculatePowerValues(vehicleData: VehicleData): { powerPS: number, powerKW: number } {
    const model = vehicleData.model!;
    const engine = model.engine!;
    const powerPS =
        engine.powerUnit === EnginePowerUnit.HORSEPOWER
            ? engine.power
            : Math.round(engine.power! * 1.35962);
    const powerKW =
        engine.powerUnit === EnginePowerUnit.HORSEPOWER
            ? Math.round(engine.power! * 0.735499)
            : engine.power;

    return { powerPS: powerPS as number, powerKW: powerKW as number }
}

export const parseEfficiencyClass = (efficiencyClass:string) => {
    switch (efficiencyClass) {
        case 'A_PLUS_PLUS_PLUS':
            return 'A+++';
        case 'A_PLUS_PLUS':
            return 'A++';
        case 'A_PLUS':
            return 'A+';
        default:
            return efficiencyClass;
    }
}

export const getEfficiencyClassImage = (efficiencyClass: string = '') => {
    switch (efficiencyClass) {
        case 'A+++':
            return 'aplusplusplus.svg';
        case 'A++':
            return 'aplusplus.svg';
        case 'A+':
            return 'aplus.svg';
        case 'A':
            return 'a.svg';
        case 'B':
            return 'b.svg';
        case 'C':
            return 'c.svg';
        case 'D':
            return 'd.svg';
        case 'E':
            return 'e.svg';
        case 'F':
            return 'f.svg';
        case 'G':
            return 'g.svg';
        default:
            return efficiencyClass;
    }
}
